import React, { ReactElement } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons/lib/icons';

import { LeashRoutes } from 'leash/utilities/const';
import { LineItemMeta } from 'pupdocs/types';
import { getPuppyStatus } from '../utilities/Details.utilities';
import { HeaderLeftStyled, PageHeaderStyled } from './DetailsHeader.styles';

interface DetailsHeaderProps {
  puppyId: number;
  travelMethod: string;
  meta: LineItemMeta;
}

export const DetailsHeader = ({
  puppyId,
  travelMethod,
  meta,
}: DetailsHeaderProps): ReactElement | null => {
  const title = `Puppy ID: ${puppyId}`;

  const renderHeaderLeftComponent = (): ReactElement => {
    return (
      <HeaderLeftStyled>
        <span>
          <ArrowLeftOutlined onClick={() => (location.href = LeashRoutes.Packages)} />
          &nbsp;&nbsp;
          {title}
        </span>

        <div>
          Travel Method: <span>{travelMethod}</span>
        </div>
      </HeaderLeftStyled>
    );
  };

  return (
    <PageHeaderStyled
      title={<>{renderHeaderLeftComponent()}</>}
      extra={[
        <div key={1}>
          PUPPY STATUS:
          <span key={2}>{getPuppyStatus(meta)}</span>
        </div>,
      ]}
    />
  );
};
